<template>
  <div class="mt10 container" v-loading="isLoading">
    <div class="relative">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="containers mb10"
      >
        <el-breadcrumb-item :to="{ path: '/course' }"
          >课程中心</el-breadcrumb-item
        >
        <el-breadcrumb-item
          ><span class="hover">课程详情</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <chapterPlay
      :data="detail"
      :chapterList="chapterList"
      v-if="$route.query.ChapterID && chapterList && chapterList.length > 0"
      @setprogress="setprogress"
      @input="getFullsummary"
    >
    </chapterPlay>
  </div>
</template>

<script>
import { Course_GetDetail } from "@/api/course";
import chapterPlay from "./child/chapterPlay.vue";
import { Course_GetCatalogs } from "@/api/course";
export default {
  name: "chapterPlayDetaial",
  data() {
    return {
      isLoading: false,
      chapterList: null,
      detail: null,
    };
  },
  watch: {
    "$route.query.CourseID"() {
      location.reload(true);
    },
    "$route.query.ChapterID"() {
      // this.getDetail();
      this.getChapterList();
    },
  },
  components: {
    chapterPlay,
  },
  methods: {
    getFullsummary(data) {
      this.AIData = { ...data };
    },

    setprogress(progress, progress1) {
      this.detail.StudyProgress = Number(progress.toFixed(0));
      // console.log('setprogress', this.chapterList)
      this.chapterList.map((cha, chaindex) => {
        cha.Chapters.map((item, index) => {
          if (item.ID === Number(this.$route.query.ChapterID)) {
            this.chapterList[chaindex].Chapters[index].StudyProgress = Number(
              progress1.toFixed(0)
            );
          }
        });
      });
    },

    play() {
      if (!this.chapterList || this.chapterList.length === 0) {
        return this.$message.warning("没有课程内容呢");
      }
      this.tab = 2;
      let chapter = null;
      for (let i = 0; i < this.chapterList.length; i++) {
        if (chapter) {
          break;
        }
        for (const ch of this.chapterList[i].Chapters) {
          if (ch.StudyProgress !== 100 && !chapter) {
            chapter = ch;
            break;
          }
        }
      }
      if (
        !chapter &&
        this.chapterList.length > 0 &&
        this.chapterList[0].Chapters.length > 0
      ) {
        chapter = this.chapterList[0].Chapters[0];
      }
      if (chapter) {
        // this.$router.push({ query: { ...this.$route.query, ChapterID: chapter.ID } })
        this.toUrl({
          path: this.$route.path,
          query: { ...this.$route.query, ChapterID: chapter.ID },
        });
      }
    },
    handerTime(time) {
      let h = 0;
      let m = 0;
      let s = 0;
      if (time >= 3600) {
        h = parseInt(time / 3600);
      }
      h = h < 10 ? "0" + h : h;
      if (time >= 60) {
        m = parseInt((time - 3600 * h) / 60);
      }
      m = m < 10 ? "0" + m : m;
      if (time >= 0) {
        s = parseInt(time - 3600 * h - 60 * m);
      }
      s = s < 10 ? "0" + s : s;
      return h + ":" + m + ":" + s;
    },
    // getDetail(reload = false) {
    //   this.chapterList = null;
    //   this.detail = null;
    //   if (!reload) {
    //     this.isLoading = true;
    //   }

    //   Course_GetChapterFile({ params: this.$route.query }).then((res) => {
    //     this.chapterList = [
    //       {
    //         ChapterID: 0,
    //         ChapterName: "string",
    //         FilePath: "string",
    //         Duration: 0,
    //         LastDuration: 0,
    //         MaxDuration: 0,
    //       },
    //     ];
    //     // this.chapterList = [...res.data];
    //   });
    // },
    getChapterList() {
      Course_GetDetail({
        CourseID: this.$route.query.CourseID,
      })
        .then((res) => {
          this.detail = res.data;
        })
        .catch(() => {});
      Course_GetCatalogs({ CourseID: this.$route.query.CourseID })
        .then((res) => {
          this.chapterList = res.data;
        })
        .catch(() => {});
    },
  },
  created() {
    this.getChapterList();
  },
  destroyed() {
    if (this.testCdTimer) {
      clearInterval(this.testCdTimer);
      this.testCdTimer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.myProgress {
  .el-progress-bar {
    width: 75%;
  }
}
.Title {
  padding: 0;
  padding-top: 10px;
  font-size: 14px;
  .topics {
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 16px;
    background: #e3edff;
    color: #376ff6;
    height: 26px;
    line-height: 22px;
  }
  .keywords {
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 16px;
    background: #f1f4f6;
    color: #999999;
    height: 26px;
    line-height: 22px;
  }
}
.fullsummary {
  font-size: 14px;
  padding: 15px 20px;
  background: #f5f5f5;
  font-family: HarmonyOS_Sans_SC_Medium;
  border-radius: 6px;
  letter-spacing: 2spx; /* 增加字符间距 */
}
</style>
